<button type="button" class="bell" [class.bell--open]="open()" (click)="toggle()"
  [attr.aria-label]="label()"
  aria-haspopup="dialog" [attr.aria-expanded]="open()">
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.9 1.9 0 0 0 3.4 0"/>
  </svg>
  @if (total()) {
    <span class="bell__badge" aria-hidden="true">{{ badge() }}</span>
  }
</button>

<!-- Phone: the shared bottom sheet -- ✕, Back closes it, 85dvh, clear of the notch and home bar
     (Release 5, 31/10/2026, SHELL-05). Laptop: the dropdown under the bell, as before. -->
@if (isPhone()) {
  <app-bottom-sheet title="Notifications" [open]="open()" (openChange)="onSheetOpenChange($event)" (closed)="onSheetClosed()">
    <div class="inbox inbox--sheet">
      <ng-container *ngTemplateOutlet="content" />
    </div>
  </app-bottom-sheet>
} @else if (open()) {
  <div class="inbox" role="dialog" aria-label="Notifications">
    <ng-container *ngTemplateOutlet="content" />
  </div>
}

<ng-template #content>
    <div class="inbox__head">
      <div class="inbox__tabs" role="tablist" aria-label="Bell">
        <button type="button" role="tab" class="inbox__tab" [class.inbox__tab--on]="tab() === 'inbox'"
          [attr.aria-selected]="tab() === 'inbox'" (click)="tab.set('inbox')">Notifications</button>
        <button type="button" role="tab" class="inbox__tab" [class.inbox__tab--on]="tab() === 'new'"
          [attr.aria-selected]="tab() === 'new'" (click)="tab.set('new')" data-testid="bell-whats-new">
          What's new
          @if (unseen()) { <span class="inbox__tab-count">{{ unseen() }}</span> }
        </button>
      </div>
      @if (tab() === 'inbox' && unread()) {
        <button type="button" class="inbox__all" (click)="markAll()">Mark all read</button>
      }
    </div>
    @if (tab() === 'new') {
      <ul class="inbox__list">
        @for (n of news(); track n.id) {
          <li>
            <button type="button" class="inbox__item" [class.inbox__item--unread]="!n.seen" (click)="pickNew(n)">
              <span class="inbox__dot" aria-hidden="true"></span>
              <span class="inbox__thumb" aria-hidden="true">
                <!-- A moving preview: the real clip when there is one, else the built-in demo. -->
                @if (n.video_url) {
                  <video [src]="n.video_url" [poster]="n.poster_url || ''" [muted]="true" loop playsinline autoplay preload="metadata"></video>
                } @else if (hasDemo(n.slug)) {
                  <app-whats-new-demo [slug]="n.slug" [compact]="true" />
                } @else {
                  @if (n.poster_url) {
                    <img [src]="n.poster_url" alt="" />
                  }
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                }
              </span>
              <span class="inbox__text">
                <span class="inbox__item-title">{{ n.title }}</span>
                <span class="inbox__body">{{ n.body }}</span>
                <span class="inbox__when">{{ day(n.starts_at) }}</span>
              </span>
            </button>
          </li>
        } @empty {
          <li class="inbox__empty">No new features in the last 30 days. When we add one you can use, it shows up here.</li>
        }
      </ul>
    } @else {
    <ul class="inbox__list">
      @for (item of items(); track item.id) {
        <li>
          <button type="button" class="inbox__item" [class.inbox__item--unread]="!item.read" (click)="pick(item)">
            <span class="inbox__dot" aria-hidden="true"></span>
            <span class="inbox__icon" aria-hidden="true">
              @switch (item.kind) {
                @case ('match_ready') {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7l4 3-1.5 4.5h-5L8 10z"/></svg>
                }
                @case ('security_check') {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M12 8v4M12 16h.01"/></svg>
                }
                @case ('playlist_shared') {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h10M4 18h7"/><path d="M17 15l4 3-4 3z" fill="currentColor"/></svg>
                }
                @default {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/></svg>
                }
              }
            </span>
            <span class="inbox__text">
              <span class="inbox__item-title">{{ item.title }}</span>
              @if (item.body) {
                <span class="inbox__body">{{ item.body }}</span>
              }
              <span class="inbox__when">{{ when(item.created_at) }}</span>
            </span>
          </button>
        </li>
      } @empty {
        <li class="inbox__empty">Nothing yet. When your match is ready, or someone shares a playlist with you, it shows up here.</li>
      }
    </ul>
    }
</ng-template>
